import { useState } from 'react';
import type { DocumentRecord } from '@proofroom/schema';
import { documents } from '../api/endpoints';

export function DocumentTags({ document, onSaved }: { document: DocumentRecord; onSaved(): void }) {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  return <div className="document-tags">
    {(document.tags ?? []).map((tag) => <span className="tag" key={tag}>{tag}</span>)}
    {!editing ? <button className="btn sm ghost" onClick={() => { setValue((document.tags ?? []).join(', ')); setEditing(true); }}>Edit tags</button> :
      <form className="btn-row" onSubmit={async (e) => {
        e.preventDefault(); setBusy(true); setError('');
        try { await documents.tags(document.id, value.split(',').map((s) => s.trim()).filter(Boolean)); setEditing(false); onSaved(); }
        catch (err) { setError(err instanceof Error ? err.message : 'Could not save tags'); }
        finally { setBusy(false); }
      }}><label className="list-field">Tags, separated by commas<input className="input" aria-label={`Tags for ${document.name}`} value={value} onChange={(e) => setValue(e.target.value)} /></label>
        <button className="btn sm" disabled={busy}>Save tags</button><button className="btn sm ghost" type="button" onClick={() => setEditing(false)}>Cancel</button>
        {error && <span role="alert" className="error-text">{error}</span>}
      </form>}
  </div>;
}
